import { memo } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { Box, Button, Grid, Card, CardContent, Typography, Skeleton } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { DataGrid, ptBR } from '@mui/x-data-grid';
import { StatusCessaoEnum } from 'components/Shared/Enums/StatusCessaoEnum';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import useDetalhesCessaoHook from '../hooks/useDetalhesCessaoHook';
import ModalEnviarDocumentos from '../componentes/ModalEnvioDocumentos/ModalEnvioDocumentos';
import ModalAssinarOperacao from '../componentes/ModalAssinarOperacao/ModalAssinarOperacao';
import ModalCancelarOperacao from '../componentes/ModalCancelarOperacao/ModalCancelarOperacao';
import FiltrosTabelaDetalhes from '../componentes/FiltrosTabelaDetalhes/FiltrosTabelaDetalhes';
import SkeletonLoadingOverlay from '../componentes/SkeletonTabela/SkeletonTabela';
import './DetalhesCessao.scss';

const DetalhesCessao = ({
  atualizarGridHistoricoCessao,
  setMostrarDetalhes,
  setDadosDetalhes,
  dadosDetalhes,
  irParaJornada,
  escopoAcesso
}) => {
  const {
    setMostrarModalCancelarOperacao,
    setMostrarModalAssinarOperacao,
    setMostrarModalEnvioDocumentos,
    handleRowSelectionModelChange,
    downloadArquivoRemessaCessao,
    mostrarModalCancelarOperacao,
    handlePaginationModelChange,
    mostrarModalAssinarOperacao,
    mostrarModalEnvioDocumentos,
    loadingConsolidadosTitulos,
    rowSelectionModelFiltered,
    buscaDadosAtualizadosTela,
    dadosConsolidadosTitulos,
    loadingLinkRemessaCessao,
    loadingBtnAlterarStatus,
    statusMostraExportacao,
    voltarTelaGestaoCessao,
    handleSortModelChange,
    loadingResumoCessao,
    alterarStatusCessao,
    formatarHistorico,
    dadosResumoCessao,
    // enviarDocumentos,
    // cancelarOperacao,
    loadingHistorico,
    paginationModel,
    // assinarOperacao,
    contadorFiltros,
    dadosHistorico,
    handleFiltrar,
    toolbarTabela,
    formataValor,
    sortModel,
    rowCount,
    loading,
    columns,
    rows
  } = useDetalhesCessaoHook({
    dadosDetalhes,
    setDadosDetalhes,
    setMostrarDetalhes,
    atualizarGridHistoricoCessao
  });

  return (
    <Grid container className="detalhes-cessao-container">
      <Grid item xs={12}>
        <Box className="sessao-topo">
          <Box className="detalhes-cessao subtitulo-sessao">
            <Button className="btn-voltar-sessao" onClick={() => voltarTelaGestaoCessao()}>
              <KeyboardBackspaceIcon /> voltar
            </Button>
            <Box className="titulo-sessao">Títulos cedidos - #{dadosDetalhes.NUMEROBORDEROONE7}</Box>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={7} className="card-item-detalhes">
        <Card className="card-resumo">
          <CardContent>
            <Typography className="titulo-card">Resumo da operação</Typography>

            {loadingResumoCessao && (
              <Grid container spacing={2} className="grid-itens-resumo">
                <Grid item xs={12}>
                  <Box className="item-label">Status:</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Qtd. de títulos enviados</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Qtd. de títulos aprovados</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Data da solicitação</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Data da análise</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Taxa</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">TED</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Valor total</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Valor à receber</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Box className="item-label">Intenção da operação</Box>
                  <Skeleton
                    className="skeleton-custom"
                    animation="wave"
                    variant="text"
                    width="90%"
                    height={32}
                  />
                </Grid>
              </Grid>
            )}

            {!loadingResumoCessao && (
              <Grid container spacing={2} className="grid-itens-resumo">
                <Grid item xs={12}>
                  <Box className="item-label">Status:</Box>
                  <Box className={`item-badge-status color-${dadosResumoCessao.status}`}>
                    {dadosResumoCessao.descricaoStatus}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Qtd. de títulos enviados</Box>
                  <Box className="item-valor">{dadosResumoCessao.qtdEnviados}</Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Qtd. de títulos aprovados</Box>
                  <Box className="item-valor">{dadosResumoCessao.qtdAprovados}</Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Data da solicitação</Box>
                  <Box className="item-valor">
                    {moment(dadosResumoCessao.dataSolicitacao).format('DD/MM/yyyy')}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Data da análise</Box>
                  <Box className="item-valor">
                    {dadosResumoCessao.dataAnalise
                      ? moment(dadosResumoCessao.dataAnalise).format('DD/MM/YYYY [às] HH:mm:ss')
                      : '- -'}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Taxa</Box>
                  <Box className="item-valor">
                    {dadosResumoCessao.taxa ? `${formataValor(dadosResumoCessao.taxa)}% a.m.` : '- -'}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">TED</Box>
                  <Box className="item-valor">
                    {dadosResumoCessao.ted ? formataValor(dadosResumoCessao.ted) : '- -'}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Valor total</Box>
                  <Box className="item-valor">R$ {formataValor(dadosResumoCessao.valorTotal ?? 0)}</Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Valor à receber</Box>
                  <Box className="item-valor">
                    R$ {formataValor(dadosResumoCessao.valorReceber ?? 0)}
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box className="item-label">Intenção da operação</Box>
                  <Box className="item-valor">{dadosResumoCessao.intencao}</Box>
                </Grid>
                {dadosResumoCessao.exibirBotaoDownload &&
                  escopoAcesso &&
                  escopoAcesso.plataforma_capital_flow &&
                  escopoAcesso.plataforma_capital_flow.componente &&
                  escopoAcesso.plataforma_capital_flow.componente['link-arquivo-remessa-cessao'] && (
                    <Grid item xs={6}>
                      <Box className="item-label">Arquivo De-para</Box>
                      {!loadingLinkRemessaCessao && (
                        <Box
                          className={`badge-remessa color-${dadosResumoCessao.existeRemessa ? 'disponivel' : 'indisponivel'}`}
                          onClick={
                            dadosResumoCessao.existeRemessa
                              ? () => downloadArquivoRemessaCessao()
                              : undefined
                          }
                        >
                          {dadosResumoCessao.existeRemessa ? (
                            <>
                              Download <CloudDownloadIcon sx={{ fontSize: '13px' }} />
                            </>
                          ) : (
                            <>Indisponivel</>
                          )}
                        </Box>
                      )}
                      {loadingLinkRemessaCessao && (
                        <Skeleton
                          className="skeleton-custom"
                          animation="wave"
                          variant="text"
                          width="90%"
                          height={32}
                        />
                      )}
                    </Grid>
                  )}
              </Grid>
            )}

            {!loadingResumoCessao && (
              <Box className="acoes-resumo">
                {dadosResumoCessao.codStatus === StatusCessaoEnum.INDEFERIDO &&
                  escopoAcesso?.plataforma_oneshell?.componente['jornada-capital-flow'] && (
                    <Button variant="contained" className="btn-criar" onClick={() => irParaJornada()}>
                      Criar nova cessão
                    </Button>
                  )}

                {/* Foram removidos pois posteriormente sera utilizado */}
                {/* {dadosResumoCessao.codStatus === StatusCessaoEnum.PENDENCIAS && (
                  <Button
                    variant="contained"
                    className="btn-criar"
                    onClick={() => enviarDocumentos(dadosResumoCessao)}
                  >
                    Enviar documentos
                  </Button>
                )} */}

                {/* {dadosResumoCessao.codStatus === StatusCessaoEnum.DEFERIDO && (
                  <Box>
                    <Button className="btn-cancelar" onClick={() => cancelarOperacao(dadosResumoCessao)}>
                      Cancelar operação
                    </Button>

                    <Button
                      variant="contained"
                      className="btn-criar"
                      onClick={() => assinarOperacao(dadosResumoCessao)}
                    >
                      Aceitar operação
                    </Button>
                  </Box>
                )} */}
              </Box>
            )}
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={5} className="card-item-detalhes">
        <Card className="card-historico">
          <CardContent className="card-content-historico">
            <Typography className="titulo-card">Histórico da operação</Typography>
            <Box className="linha-tempo">
              <Box className="coluna-linha">
                {loadingHistorico && (
                  <>
                    {Array.from({ length: 3 }).map((_, index) => (
                      <Box key={index} className="item-historico">
                        <Box className="conteudo">
                          <Skeleton
                            variant="text"
                            className="skeleton-custom"
                            animation="wave"
                            width="80%"
                            height={24}
                          />
                          <Skeleton
                            variant="text"
                            className="skeleton-custom"
                            width="100%"
                            animation="wave"
                          />
                        </Box>
                        <Box className="hora-data">
                          <Skeleton
                            variant="text"
                            className="skeleton-custom"
                            animation="wave"
                            width="100%"
                            height={24}
                          />
                          <Skeleton
                            variant="text"
                            className="skeleton-custom"
                            animation="wave"
                            width="100%"
                          />
                        </Box>
                      </Box>
                    ))}
                  </>
                )}

                {!loadingHistorico &&
                  dadosHistorico.map((item, index) => {
                    const horaEDataFormatadas = formatarHistorico(item.DTHRINSERT);
                    return (
                      <Box key={index} className="item-historico">
                        <Box className="conteudo">
                          <Typography className="titulo-historico">{item.TITULOOCORRENCIA}</Typography>
                          <Typography className="descricao-historico">{item.DESCRICAO}</Typography>
                        </Box>
                        <Box className="hora-data">
                          <Box className="label-hora">{horaEDataFormatadas.hora}</Box>
                          <Box className="label-data">{horaEDataFormatadas.data}</Box>
                        </Box>
                      </Box>
                    );
                  })}

                {dadosHistorico.length === 0 && !loadingHistorico && (
                  <Box className="nenhum-historico">
                    <Typography>Nenhum histórico encontrado para esta cessão.</Typography>
                  </Box>
                )}
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {statusMostraExportacao.includes(dadosResumoCessao.status) && (
        <Grid item xs={12} className="exportar-titulos">
          <Grid container>
            <Grid item xs={12} md={9} className="label-exportar-titulos">
              <Box>Baixe os arquivos e envie pela plataforma digital para continuar o Capital Flow</Box>
            </Grid>
            <Grid item xs={12} md={3} className="btn-exportar-titulos">
              <Button onClick={() => alert('baixar títulos')}>
                <SaveAltIcon /> Exportar títulos
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid item xs={12}>
        <Box className="titulos-header">
          <Typography className="titulo-sessao-grid">Títulos cedidos</Typography>
          <Box className="valores">
            <Grid container className="grid-container-valores">
              {loadingConsolidadosTitulos && (
                <Grid item xs={12}>
                  <Skeleton
                    variant="rectangular"
                    className="skeleton-custom"
                    animation="wave"
                    height="60"
                    width="100%"
                  />
                </Grid>
              )}

              {!loadingConsolidadosTitulos && (
                <>
                  <Grid item xs={12} md={6}>
                    {dadosResumoCessao.codStatus === StatusCessaoEnum.INDEFERIDO && (
                      <span className="rejeitados-bruto-valor">
                        ❌ <b>{dadosConsolidadosTitulos.QTDETITULOSREJEITADOS ?? 0}</b> títulos
                        rejeitados
                      </span>
                    )}
                    {dadosResumoCessao.codStatus !== StatusCessaoEnum.INDEFERIDO && (
                      <Box className="status-titulos">
                        <span className="rejeitados-bruto-valor aprovados">
                          <LibraryAddCheckIcon />
                          <b>{dadosConsolidadosTitulos.QTDETITULOSAPROVADOS ?? 0}</b>
                          &nbsp;títulos aprovados
                        </span>

                        {dadosConsolidadosTitulos.QTDETITULOSPENDENCIAS > 0 && (
                          <span className="rejeitados-bruto-valor pendencia">
                            <AccessAlarmIcon />
                            <b>{dadosConsolidadosTitulos.QTDETITULOSPENDENCIAS ?? 0}</b>
                            &nbsp;títulos com pendência
                          </span>
                        )}
                      </Box>
                    )}
                  </Grid>
                  <Grid className="rejeitados-bruto-valor" item xs={6} md={3}>
                    <span>Bruto</span>:
                    <b> R$ {formataValor(dadosConsolidadosTitulos.VALORBRUTO ?? 0)}</b>
                  </Grid>
                  <Grid className="rejeitados-bruto-valor" item xs={6} md={3}>
                    <span>Líquido</span>:
                    <b> R$ {formataValor(dadosConsolidadosTitulos.VALORLIQUIDO ?? 0)}</b>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Box>

        <Box className="box-data-grid">
          <FiltrosTabelaDetalhes onFiltrar={handleFiltrar} contadorFiltros={contadorFiltros} />
          <Grid container>
            <Grid className="content-datagrid-lista-titulos" item xs={12}>
              <DataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                className="data-grid-cessao"
                pageSizeOptions={[10, 25, 50, 100]}
                disableRowSelectionOnClick
                rowSelectionModel={rowSelectionModelFiltered}
                onRowSelectionModelChange={handleRowSelectionModelChange}
                slots={{
                  toolbar: toolbarTabela,
                  loadingOverlay: SkeletonLoadingOverlay
                }}
                localeText={{
                  ...ptBR.components.MuiDataGrid.defaultProps.localeText
                }}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={handlePaginationModelChange}
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                rowCount={rowCount}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <ModalEnviarDocumentos
        open={mostrarModalEnvioDocumentos}
        onClose={() => setMostrarModalEnvioDocumentos(false)}
        dadosDetalhes={dadosDetalhes}
        buscaDadosAtualizadosTela={buscaDadosAtualizadosTela}
      />

      <ModalAssinarOperacao
        open={mostrarModalAssinarOperacao}
        onClose={() => setMostrarModalAssinarOperacao(false)}
        alterarStatusCessao={alterarStatusCessao}
        loadingBtnAlterarStatus={loadingBtnAlterarStatus}
      />

      <ModalCancelarOperacao
        open={mostrarModalCancelarOperacao}
        onClose={() => setMostrarModalCancelarOperacao(false)}
        alterarStatusCessao={alterarStatusCessao}
        loadingBtnAlterarStatus={loadingBtnAlterarStatus}
      />
    </Grid>
  );
};

export default memo(DetalhesCessao);
